module.exports = __webpack_public_path__ + "image-9b86fedd2ecd.png";